"use client";

import { useEffect } from "react";
import { useRouter } from "@/i18n/navigation";
import { getMe } from "@/lib/auth-store";

/**
 * Client-side escape hatch for public pages that make no sense to signed-in
 * members (the marketing landing). Auth lives in localStorage, so the server
 * can't tell members apart — this mounts inside the public page and replaces
 * the route after mount when a session exists. Anonymous visitors render
 * nothing and stay put.
 */
export function MemberRedirect({ to }: { to: string }) {
  const router = useRouter();

  useEffect(() => {
    if (getMe() !== null) router.replace(to);
  }, [router, to]);

  return null;
}
